import { render, staticRenderFns } from "./Empleado.vue?vue&type=template&id=4dc601d0&scoped=true&"
import script from "./Empleado.vue?vue&type=script&lang=js&"
export * from "./Empleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc601d0",
  null
  
)

export default component.exports